import React, { ReactNode } from 'react';
import styled from 'styled-components';
import { TYPO } from '../consts';
import { COLORS } from '../consts/colors';
import { CaretDown16 } from '../icons/16/caretDown';

const ItemContainer = styled.div`
  background: transparent;
`;

interface HeaderProps {
  $disabled: boolean;
}

const Header = styled.div<HeaderProps>`
  display: flex;
  align-items: center;
  gap: 28px;
  cursor: ${({ $disabled }) => ($disabled ? 'not-allowed' : 'pointer')};
  opacity: ${({ $disabled }) => ($disabled ? 0.5 : 1)};
  padding: 0;
  user-select: none;
`;

const Arrow = styled.div<{ $expanded: boolean }>`
  display: flex;
  align-items: center;
  transition: transform 0.2s;
  transform: rotate(${({ $expanded }) => ($expanded ? 270 : 0)}deg);
  color: ${COLORS.primary300};
`;

const Title = styled.div`
  ${TYPO.subtitle1}
  color: ${COLORS.primary300};
`;

const Content = styled.div`
  ${TYPO.body1}
  margin: 12px 44px 0;
  color: ${COLORS.black};
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export interface CollapseItemProps {
  title: ReactNode;
  name?: string | number;
  disabled?: boolean;
  children: ReactNode;
  expanded?: boolean;
  onToggle?: (expanded: boolean) => void;
}

export const UiCollapseItem: React.FC<CollapseItemProps> = ({
  title,
  disabled = false,
  children,
  expanded = false,
  onToggle,
}) => {
  const handleClick = () => {
    if (!disabled && onToggle) {
      onToggle(!expanded);
    }
  };

  return (
    <ItemContainer>
      <Header
        $disabled={disabled}
        onClick={handleClick}
      >
        <Arrow $expanded={expanded}>
          <CaretDown16 />
        </Arrow>
        <Title>{title}</Title>
      </Header>
      {expanded && <Content>{children}</Content>}
    </ItemContainer>
  );
};
